import { render, staticRenderFns } from "./newNucleinData.vue?vue&type=template&id=0c6c76f0&scoped=true&"
import script from "./newNucleinData.vue?vue&type=script&lang=js&"
export * from "./newNucleinData.vue?vue&type=script&lang=js&"
import style0 from "./newNucleinData.vue?vue&type=style&index=0&id=0c6c76f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c76f0",
  null
  
)

export default component.exports